<!--
 * @Description: 酒店详情
 * @Author: wjh
 * @Date: 2021-3
 * @LastEditors: wjh
 -->
<template>
    <div id="hotelList">
        <Loading v-if="show"></Loading>
        <div class="hotelList_container">
            <header class="hotel-header">
                <div class="header-left" @click="goBack">
                    <div class="header-cricle">
                        <img src="../../assets/return-white.png">
                    </div>
                </div>
                <div class="header-title">
                    订单支付
                </div>
                <div class="header-right">
                </div>
            </header>
            <div class="hotelList_content">
                <div class="choosePaymentMethod">
                    <div class="payInfo_choosePaymentMethod">
                        <div class="choosePaymentMethod_title">
                          <h5>订单基本信息</h5>
                        </div>
                        <div class="order-info">
                            <div class="order-row">
                                <div class="order-label">
                                    酒店名称
                                </div>
                                <div class="order-input">
                                    <div class="room-number">
                                        {{orderInfo.hotellname}}
                                    </div>
                                </div>
                            </div>
                            <div class="order-row">
                                <div class="order-label">
                                    酒店地址
                                </div>
                                <div class="order-input">
                                    <div class="room-number">
                                        {{orderInfo.hoteladdress}}
                                    </div>
                                </div>
                            </div>
                            <div class="order-row">
                                <div class="order-label">
                                    房间类型
                                </div>
                                <div class="order-input">
                                    <div class="room-number">
                                        {{orderInfo.showname}}
                                    </div>
                                </div>
                            </div>
                            <div class="order-row">
                                <div class="order-label">
                                    房间数量
                                </div>
                                <div class="order-input">
                                    <div class="room-number">
                                        {{orderInfo.showroomcount}}
                                    </div>
                                </div>
                            </div>
                            <div class="order-row">
                                <div class="order-label">
                                    预定姓名
                                </div>
                                <div class="order-input">
                                    <div class="room-number">
                                        {{orderInfo.resname}}
                                    </div>
                                </div>
                            </div>
                            <div class="order-row">
                                <div class="order-label">
                                    手机号码
                                </div>
                                <div class="order-input">
                                    <div class="room-number">
                                        {{orderInfo.resphone}}
                                    </div>
                                </div>
                            </div>
                            <div class="order-row">
                                <div class="order-label">
                                    身份证号
                                </div>
                                <div class="order-input">
                                    <div class="room-number">
                                        {{orderInfo.identitycard}}
                                    </div>
                                </div>
                            </div>
                            <div class="order-row">
                                <div class="order-label">
                                    订单金额
                                </div>
                                <div class="order-input">
                                    <div class="room-number" style="color: #f56c6c;">
                                        ￥{{orderInfo.money}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="payInfo_choosePaymentMethod">
                        <div class="choosePaymentMethod_title">
                          <h5>选择支付方式</h5>
                        </div>
                        <div class="payInfo_PaymentMethod">
                          <van-radio-group v-model="checked_Pay.paycode">
                            <van-cell-group>
                              <div v-if="onLineList.length">
                                <!-- <div class="onLine">线上支付</div> -->
                                <div v-for="(item, index) in onLineList" :key="index">
                                  <div class="radio_item" v-if="item.paytype>=4">
                                    <img v-if="item.paylogo" :src="item.paylogo" alt />
                                    <van-cell
                                      :title="item.payname"
                                      clickable
                                      @click="checkedPay(item)"
                                      ><p v-html="item.remake"></p>
                                      <van-radio
                                        slot="right-icon"
                                        :name="item.paycode"
                                      />
                                    </van-cell>
                                  </div>
                                  <div class="radio_item" v-else>
                                    <img :src="item.paylogo" alt />
                                    <van-cell
                                      :title="item.payname"
                                      clickable
                                      @click="checkedPay(item)"
                                      >{{ item.remake }}
                                      <van-radio
                                        slot="right-icon"
                                        :name="item.paycode"
                                      />
                                    </van-cell>
                                  </div>
                                </div>
                              </div>
                            </van-cell-group>
                          </van-radio-group>
                        </div>
                        <div class="submit">
                          <div class="submitBtn" @click="goPay">
                            {{ submitMsg }}
                          </div>
                        </div>
                  </div>
                </div>
                <div class="loading" v-if="loading">
                    <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...</van-loading>
                </div>
            </div>
        </div>
        <div class="modal" v-show="payShow">
          <div class="modal-close" @click="closePay">
            <img src='../../assets/close.png'>
          </div>
          <div class="modal-con">
           <!--  <div class="QR-code">
              <div id="qrcode"></div>
            </div> -->
            <div class="pay-code">
              <img :src="payCode">
            </div>
            <div class="code-text">
              请用{{checked_Pay.payname}}
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import Footer from '@components/Footer.vue'
import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'
export default {
    name: 'hotelInitPay',
    components: {
        Loading
    },
    data() {
        return {
          publicTools: {}, //通用publicSignup
          params: {
              m: '',
              muid: '',
              hrcid: '',
          },
          meetingInfo: '',
          show: false,
          loading: false,
          red: '',
          navShow: true,
          navhomeUrl: '',
          orderInfo: '',
          onLineList: [],
          checked_Pay: {
            //选中支付方式的数据
            paytype: '',
            paycode: '',
            IsPayRed: '',
            payname: '',
          },
          showSubmitBtn: true, //提交中按钮
          submitMsg: '立即支付',
          orderid: '',
          payShow: false,
          payCode: '',
        }
    },
    created() {
        this.params = this.$route.query
        this.red = this.params.red
        this.publicTools = new publicSignup()
        console.log(this.publicTools)
        let opts = this.params
        this.hotelSignInitPayConfig(opts)
    },
    mounted(){

    },
    methods: {
        async hotelSignInitPayConfig(opts) {
            try {
                this.loading = true
                let res = await this.$http.hotelSignInitPayConfig(opts)
                console.log(res)
                if (res.Code === 1000) {
                    this.loading = false
                    this.orderInfo = res.wqzh_Hotel_Record
                    this.onLineList = res.PayEntitys
                    this.checked_Pay.paytype = res.PayEntitys[0].paytype
                    this.checked_Pay.paycode = res.PayEntitys[0].paycode
                    this.checked_Pay.IsPayRed = res.PayEntitys[0].IsPayRed
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'primary',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },
        // 去支付
        goPay() {
          if (this.checked_Pay.paycode) {
            if (this.checked_Pay.paytype > 4 ){
              this.$router.push({
                path: '/signup/uploadProof',
                query: { m: this.m,red: this.$route.query.red },
              })
            }else{
              this.submitMsg = '等待支付...'
              let params = {
                m: this.params.m,
                muid: this.params.muid,
                //Orderid: this.ticketData.Orderid,
                PayType: Number(this.checked_Pay.paytype),
                PayCode: this.checked_Pay.paycode,
                IsMobile: this.publicTools.isMobile(),
                IsWxClient: this.isWeiXin(),
              }
              this.pay(params)
            }
          } else {
            this.submitMsg = '跳转中...'
            this.$router.push({
              path: '/hotelOrderList',
              query: { m: this.m },
            })
          }
        },
        async pay(params) {
          var _that = this
          if (this.showSubmitBtn) {
            console.log('提交的参数', params)
            this.showSubmitBtn = false
            try {
              let res = await this.$http.hotelSignCreatePayOrder(params)
              console.log(res)
              if (res.Code === 1000) {
                if ( this.checked_Pay.paytype === 1 ){
                  if ( this.checked_Pay.IsPayRed ){
                    window.location.href = res.callback_url
                  }else{
                    //console.log(decodeURIComponent(res.code_url))
                    this.payShow = true
                    //this.qrcode(decodeURIComponent(res.code_url))
                    this.payCode = 'data:image/gif;base64,' + res.code_url
                    this.orderid = res.orderid
                    _that.timer = setInterval(() => {
                      _that.QueryOrder()
                    }, 1000)
                  }
                }else if (this.checked_Pay.paytype === 4) {
                  // E-pay: jump to cashier directly
                  window.location.href = decodeURIComponent(res.code_url)
                }else if (this.checked_Pay.paytype === 3) {
                  //微信支付
                  this.jsApiCall(res)
                  this.orderid = res.orderid
                }
              }
              this.showSubmitMsg()
              this.showSubmitBtn = true
            } catch (err) {
              console.log(err)
            }
          }
        },
        /**
         * 微信支付
         */
        jsApiCall(par) {
          if (this.isWeiXin()) {
            var _that = this
            window.WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              par.payParm,
              function(res) {
                window.WeixinJSBridge.log(res.err_msg)
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                  console.log('res', res)

                  _that.timer = setInterval(() => {
                    _that.QueryOrder()
                  }, 1000)
                } else {
                  _that.$notify({
                    massage: '您已取消支付',
                    type: 'danger',
                    duration: '5000',
                  })
                  console.log('error', res)
                }
              }
            )
          } else {
            if (par.mweb_url) {
              window.location.href = par.mweb_url
            } else {
              this.$notify({
                massage: par.Msg,
                type: 'danger',
              })
            }
          }
        },
        //查询订单是否支付状态
        async QueryOrder() {
          try {
            let params = {
              m: this.m,
              orderid: this.orderid,
            }
            let _Res = await this.$http.hotelSignQueryOrder(params)

            if (_Res.Code === 1000) {
              clearInterval(this.timer)
              this.$router.push({
                //path: '/signup/meetingsignup',
                //query: { m: this.m },
                //query: this.$route.query
              })
            } else {
              this.$notify({
                massage: _Res.Msg,
                type: 'danger',
              })
            }
          } catch (err) {
            console.log(err)
          }
        },

        // 选择支付方式
        checkedPay(item) {
          this.checked_Pay.paytype = item.paytype
          this.checked_Pay.paycode = item.paycode
          this.checked_Pay.IsPayRed = item.IsPayRed
          this.checked_Pay.payname = item.payname
          this.showSubmitMsg()
        },
        showSubmitMsg() {
          if (!this.checked_Pay.paycode) {
            this.submitMsg = '确定'
          } else {
            this.submitMsg = '立即支付'
          }
        },
        closePay(){
          this.payShow = false
          this.submitMsg = '立即支付'
        },
        goBack(){
            this.$router.go(-1);
        },
        //判断是否为微信访问
        isWeiXin() {
          //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
          var ua = window.navigator.userAgent.toLowerCase()
          //通过正则表达式匹配ua中是否含有MicroMessenger字符串
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true
          } else {
            return false
          }
        },
    },
    watch: {

    },
}
</script>
<style lang="scss" scoped>
.hotel-banner .swiper-slide {
    position: relative;
    text-align: center;
}

.hotel-banner img {
    width: 100%;
    height: 450px;
    object-fit: cover;
}

.hotel-header{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 80px;
    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%);
    display: flex;
    align-items: center;
    .header-left,
    .header-right{
        width: 100px;
        text-align: center;
        img{
            width: 40px;
            height: 40px;
        }
    }
    .header-title{
        flex: 1;
        text-align: center;
        font-size: 30px;
        color: #fff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}

.hotelList_content {
    padding: 80px 0 90px;
    .order-info{
        background: #ffffff;
        .order-row{
            border-bottom: 1px solid #e2e8f0;
            padding: 20px;
            font-size: 28px;
            color: #64748b;
            display: flex;
            align-items: center;
            .order-label{
                width: 160px;
                img{
                    width: 30px;
                    height: 30px;
                    vertical-align: middle;
                }
            }
            .order-tel{
                width: 100px;
                border-right: 1px solid #e2e8f0;
            }
            .order-input{
                flex: 1;
                display: flex;
                align-items: center;
                select,
                input{
                    width: 100%;
                    border: none;
                    height: 100%;
                    background: none;
                    padding: 0 20px;
                }
                span{
                    color: #64748b;
                    margin-left: 10px;
                }
                .room-number{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    input{
                        width: 60px;
                    }
                }
            }
            .order-room{
                flex: 1;
                display: flex;
                align-items: center;
                span{
                    padding: 3px 20px;
                    background: #f1f5f9;
                    color: #64748b;
                    margin-right: 20px;
                }
            }
            .order-ico{
                width: 40px;
                text-align: center;
                img{
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }
    .payInfo_choosePaymentMethod {
          font-size: 28px;
          margin-bottom: 20px;
          padding: 10px 20px;
          .choosePaymentMethod_title {
             h5 {
              border-bottom: 1px solid #e2e8f0;
              padding-bottom: 15px;
              padding-top: 5px;
            }
          }
          .underTheLine,
          .onLine {
            font-size: 26px;
            height: 60px;
            line-height: 60px;
            color: #64748b;
          }

          .radio_item {
            display: flex;
            align-items: center;
            padding: 4px 4px;
            border-bottom: 1px solid #e2e8f0;
            justify-content: center;
            > img {
              width: 64px;
              height: 64px;
            }
          }

          .submit {
            margin-top: 80px;
            .submitBtn {
              height: 80px;
              line-height: 80px;
              background: linear-gradient(135deg, #3b82f6, #6366f1);
              color: #fff;
              text-align: center;
            }
          }
        }
}


</style>
<style lang="scss">
.payInfo_PaymentMethod {
    .van-radio-group {
      .van-cell__title {
        flex: none;
        > span {
          font-size: 30px;
          line-height: 60px;
        }
      }
      .van-cell__value {
        flex: 1;
        padding: 0 20px;
        position: static;
        text-align: center;
        font-size: 28px;
        line-height: 60px;
      }
      .van-radio__icon {
        height: 60px;
        text-align: center;
      }
      .van-icon {
        font-size: 28px;
        line-height: initial;
        margin-top: 40%;
      }
    }
    .van-hairline--top-bottom {
      position: static;
    }
  }
</style>